import {
  prequalificationField,
  fieldAddProductVulcan,
  errorNotePrequalificationField,
  Yes,
  textOnAddProduct
} from '../../utils/constant';

export const preQualificationSectionErrorHandler = ({
  key,
  value,
  result,
  ref,
  fieldsValue,
  sections
}) => {
  if (prequalificationField.includes(key)) {
    fieldsValue.push(value);
    if (value === Yes) {
      result[errorNotePrequalificationField] = {
        text: '',
        ref
      };
    } else if (!fieldsValue.includes(Yes)) {
      delete result[errorNotePrequalificationField];
    }
  }
  if (
    sections &&
    sections[1] &&
    sections[1].fields &&
    sections[1].fields.name !== 'Prequalification'
  ) {
    delete result[errorNotePrequalificationField];
  }
};

export const addProductVulcanErrorHandler = ({ value, key, ref, result }) => {
  if (key === fieldAddProductVulcan) {
    if (value.length < 3) {
      result[key] = {
        text: textOnAddProduct,
        ref
      };
    }
  }
};
